import * as Actions from './customers.combine.actions';

const initialState = {
  combineCustomersModalId: null,
  confirmCustomersModalId: null,
};

export const customersCombine = (state = initialState, action) => {
  const { modalId } = action;

  switch (action.type) {
    case Actions.COMBINE_CUSTOMERS_MODAL_OPEN:
      return {
        ...state,
        combineCustomersModalId: modalId,
      };
    case Actions.COMBINE_CUSTOMERS_CONFIRMATION_MODAL_OPEN:
      return {
        ...state,
        confirmCustomersModalId: modalId,
      };
    default:
      return state;
  }
};

export { namespace } from './customers.combine.reducer.metadata';
